import { StatusBadgeType } from '../../APIs/projectApi';

const statusMap: Record<
    StatusBadgeType,
    {
        label: string;
        style: React.CSSProperties; // style オブジェクト
    }
> = {
    ok: {
        label: '良好',
        style: { color: '#07f954' },
    },
    busy: {
        label: '混雑',
        style: { color: '#ffea00' },
    },
    empty: {
        label: '不足',
        style: { color: '#ff0000' },
    },
    unknown: {
        label: '未確認',
        style: { color: '#4a5568' },
    },
};

export const StatusBadge = ({ status }: { status: StatusBadgeType }) => {
    const { label, style } = statusMap[status];
    return (
        <span>
            <svg
                style={style}
                width="10"
                height="10"
                viewBox="0 0 8 8"
                fill="currentColor"
                aria-hidden="true"
                className="inline-block align-middle"
            >
                <circle cx="4" cy="4" r="4" />
            </svg>
            <span>{label}</span>
        </span>
    );
};
